/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SsNgrxRouterStoreStateComponent as ɵb} from './lib/ss-ngrx-router-store-state.component';
export {ROUTER_FEATURE_KEY as ɵa} from './lib/ss-ngrx-router-store.config';